exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".em-payment-modal .modal-header .close{display:none}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/DraftEventMembers/EventMemberPaymentModal.vue"],"names":[],"mappings":"AACA,uCACE,YAAc,CACf","file":"EventMemberPaymentModal.vue","sourcesContent":["\n.em-payment-modal .modal-header .close {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36e14fc4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DraftEventMembers/EventMemberPaymentModal.vue
// module id = 1452
// module chunks = 18